import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from './../icon/icon.module';
import { AddLineComponent } from './add-line.component';

@NgModule({
  declarations: [AddLineComponent],
  entryComponents: [AddLineComponent],
  exports: [AddLineComponent],
  imports: [IconModule, CommonModule],
})
export class AddLineModule {}
export { AddLineComponent } from './add-line.component';
